import React from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { moreResults } from '../data/testimonials';
export function MoreResults() {
  return <section className="border-t border-primary/20 bg-surface py-16 sm:py-20" aria-labelledby="results-title" data-id="element-125" data-mp="28eg99jwmki7p">
      <div className="mx-auto max-w-6xl px-4" data-id="element-126" data-mp="2d7hs22zyd1wk">
        <SectionHeading id="results-title" data-id="element-127" data-mp="2h7s3hv6ikkit">What <span className="text-accent" data-id="element-128" data-mp="2h6qlf6r2yxrl">professionals</span> say</SectionHeading>
        <div className="mt-10 grid gap-5 md:grid-cols-3" data-id="element-129" data-mp="2m5tlsdw48ft8">
          {moreResults.map(([initials, name, place, quote], index) => <motion.article key={name} initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.04,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex flex-col rounded-2xl border border-primary/40 bg-background p-6 shadow-glow" data-id="element-130" data-mp="2r70tye267h0f" data-mpi={index}>
              <QuoteIcon className="h-6 w-6 text-accent" aria-hidden="true" data-id="element-131" data-mp="3neqyr6oaedt8" />
              <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-muted" data-id="element-132" data-mp="3ilxuejwqd7ho">“{quote}”</blockquote>
              <div className="mt-6 flex items-center gap-3 border-t border-primary/30 pt-4" data-id="element-133" data-mp="3do61bmkcnfbw">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg border border-primary/60 bg-surface text-sm font-extrabold text-primary-strong" data-id="element-134" data-mp="38puvro137qzh">
                  {initials}
                </span>
                <span data-id="element-135" data-mp="55qhxle2ociy">
                  <b className="block text-sm text-foreground" data-id="element-136" data-mp="8ggf7desaer">{name}</b>
                  <small className="text-xs text-muted" data-id="element-137" data-mp="at7ca159v3y">{place}</small>
                </span>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}